import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "mr-3"
        }))
      : (_openBlock(), _createBlock(_component_v_window, {
          key: 1,
          modelValue: _ctx.currentStep,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentStep) = $event)),
          class: "mx-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: "selectUser" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"flex-wrap":"nowrap"},
                  class: "pb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "d-flex pr-2 pt-3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.searchUser,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchUser) = $event)),
                          label: "Rechercher",
                          outlined: "",
                          "hide-details": "",
                          "data-cy": "SelectUser-recherche",
                          density: "compact",
                          "append-inner-icon": "$search",
                          clearable: "",
                          "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchUser = ''))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list, {
                  subheader: "",
                  style: _normalizeStyle(`height: ${_ctx.height} ; overflow-y: auto`),
                  lines: "two"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtredUsers, (user, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                        (!_ctx.multiple)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              class: _normalizeClass(_ctx.getUserItemClass(user.id)),
                              onClick: ($event: any) => (!_ctx.multiple ? _ctx.selectUser(user) : null),
                              "data-cy": 'selectUser-user-' + i,
                              rounded: "xl",
                              density: "compact"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_avatar, { color: "secondary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getUserBigram(user)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  icon: 
                                            user.id === _ctx.selectedUserId
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        
                                }, null, 8, ["icon"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getUserDisplayName(user)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (user.email)
                                  ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(user.email), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick", "data-cy"]))
                          : (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              class: _normalizeClass(_ctx.getUserItemClass(user.id)),
                              onClick: ($event: any) => (!_ctx.multiple ? _ctx.selectUser(user) : null),
                              "data-cy": 'selectUser-user-' + i,
                              rounded: "xl",
                              density: "compact"
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.selectedUsers,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                                  class: "pa-0 ma-0",
                                  value: user.id
                                }, null, 8, ["modelValue", "value"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getUserDisplayName(user)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (user.email)
                                  ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(user.email), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick", "data-cy"]))
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
  ]))
}